
const myApplication = {
  state: {
    location: ''
  },
  mutations: {
    getUrl (state, payload) {
      state.location = state.location.concat(payload)
    }
  }
}
export default myApplication



// WEBPACK FOOTER //
// ./src/store/modules/myApplication.js